import { colors } from "../styles/theme";

const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

// layout.js

export const pageLayout = {
  pageMaxWidth: 1280,

  sectionPadding: "72px 0",
  sectionPaddingLg: "96px 0",

  containerPadding: "0 24px",
};

export const sectionWrapper = (bg) => ({
  background: bg,
  padding: pageLayout.sectionPadding,
});

export const sectionInner = {
  maxWidth: pageLayout.pageMaxWidth,
  margin: "0 auto",
  padding: pageLayout.containerPadding,
};


export const pageWrapper = {
  minHeight: "100vh",
  background: "#ffffff",
};

export const header = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 0,
    padding: isMobile ? "10px 12px" : "12px 24px",
    borderBottom: `1px solid ${colors.border}`,
    background: colors.white,
    position: "sticky",
    top: 0,
    zIndex: 50,
  },

  brandContainer: {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? 6 : 10,
    cursor: "pointer",
  },

  brandText: {
    fontWeight: 700,
    fontSize: isMobile ? "0.9rem" : "1rem",
    color: colors.textDark,
  },

  logo: {
    height: isMobile ? 32 : 60,
    width: "auto",
    display: "block",
  },

  menu: {
    position: "absolute",
    right: 0,
    top: "calc(100% + 8px)",
    minWidth: 200,
    padding: 8,
    zIndex: 100,
  },

  menuItem: {
    padding: "12px",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: "0.95rem",
    color: colors.textDark,
  },

  menuItemDanger: {
    color: colors.danger,
  },
};


export const footer = {
  container: {
    borderTop: `1px solid ${colors.border}`,
    background: colors.bgSoft,
    padding: isMobile ? "20px 16px" : "24px",
    marginTop: "auto",
  },

  inner: {
    maxWidth: 1280,
    margin: "0 auto",
    textAlign: "center",
  },

  text: {
    fontSize: "0.85rem",
    color: colors.textMuted,
    lineHeight: 1.5,
  },

  links: {
    marginTop: 12,
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "center",
    gap: isMobile ? 8 : 16,
    fontSize: "0.85rem",
  },

  link: {
    color: colors.textMuted,
    textDecoration: "none",
  },
};

/* ---------- Page Header Layout ---------- */

export const pageHeader = {
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
};
